import { Button } from "@/components/ui/button";
import { ArrowRight, Gift, Share2, Wallet, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

const steps = [
  {
    icon: Share2,
    step: "1",
    title: "Share Your Link",
    description: "Get your unique referral link and share it with friends, family, or on social media.",
  },
  {
    icon: Gift,
    step: "2",
    title: "Friends Sign Up",
    description: "When someone uses your link to join and pay, you earn a commission instantly.",
  },
  {
    icon: Wallet,
    step: "3",
    title: "Get Paid",
    description: "Withdraw your earnings on weekdays (Mon-Fri) to your bank account instantly.",
  },
];

const Affiliate = () => {
  return (
    <section className="py-24 bg-gradient-surface overflow-hidden">
      <div className="container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-sm font-semibold text-accent uppercase tracking-wider">Affiliate Program</span>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground mt-4 mb-6">
              Earn While You{" "}
              <span className="text-gradient-gold">Share</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-10">
              Turn your network into income. Earn up to ₦4,000 for every person you refer who joins our platform. No limits on how much you can earn!
            </p>

            {/* Earnings Highlight */}
            <div className="bg-card p-6 rounded-2xl shadow-card mb-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Commission per referral</p>
                  <p className="text-4xl font-bold text-amber-600">₦4,000</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-muted-foreground mb-1">Refer 10 friends</p>
                  <p className="text-4xl font-bold text-primary">₦40,000</p>
                </div>
              </div>
            </div>

            {/* Withdrawal Days Notice */}
            <div className="bg-primary/10 border border-primary/20 p-4 rounded-xl mb-10 flex items-center gap-3">
              <Calendar className="w-5 h-5 text-primary flex-shrink-0" />
              <p className="text-sm text-foreground">
                <span className="font-semibold">Instant Withdrawals:</span> Available Monday - Friday
              </p>
            </div>

            <Link to="/signup">
              <Button variant="gold" size="lg">
                Join Affiliate Program
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>

          {/* Steps */}
          <div className="space-y-6">
            {steps.map((item, index) => (
              <div
                key={item.title}
                className="flex gap-6 p-6 rounded-2xl bg-card shadow-card hover:shadow-elevated transition-all duration-300 animate-fade-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="relative">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center">
                    <item.icon className="w-8 h-8 text-primary-foreground" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-accent flex items-center justify-center">
                    <span className="text-sm font-bold text-accent-foreground">{item.step}</span>
                  </div>
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold text-foreground mb-2">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Affiliate;
